import { SxProps, Theme } from "@mui/material/styles";
import theme from "../../theme";

const styles: SxProps<Theme> = [
  {
    "&.root": {
      "& span": {
        color: theme.palette.common.black,
        fontSize: "0.8rem",
        fontWeight: "bold",
      },
    },
    "& .checkbox": {
      marginLeft: "4px",
    },
    "& .icon": {
      width: 16,
      height: 16,
      background: theme.palette.common.white,
      "& svg": {
        marginTop: "-4px",
        marginLeft: "-4px",
        width: 24,
        height: 24,
      },
    },
  },
];

export default styles;
